import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";



@Injectable({
  providedIn: "root",
})
export class DataShareService {

  teamsArrayDataShareService: any[] = [];
  allTeamsArrayDataShareService: any[] = [];
  driversArrayDataShareService: any[] = [];
  hubsArrayDataShareService: any[] = [];
  taskArrayDataShareService: any[] = [];
  adminArrayDataShareService: any[] = [];
  dispatcherArrayDataShareService: any[] = [];
  apiKeysArrayDataShareService: any[] = [];
  oauthCredentialsArrayDataShareService: any[] = [];
  WebhookArrayDataShareService: any[] = [];
  vehicleBrandArrayDataShareService: any[] = [];
  vehicleModelArrayDataShareService: any[] = [];
  vehicleArrayDataShareService: any[] = [];
  carTypeArrayDataShareService: any[] = [];
  driverShiftArrayDataShareService: any[] = [];
  hubZoneArrayDataShareService: any[] = [];
  serviceZoneArrayDataShareService: any[] = [];
  branchArrayDataShareService: any[] = [];
  surgeZoneArrayDataShareService: any[] = [];
  areaZoneArrayDataShareService: any[] = [];
  planCreatedArrayDataShareService: any[] = [];
  planCreatedFromTaskArrayDataShareService: any[] = [];

  /** Session flags — skip master-list APIs after first successful load this login */
  private masterListsLoaded: Record<string, boolean> = {};

  constructor() { }

  setTeamsFromListResponse(result: any): void {
    this.teamsArrayDataShareService = result?.status ? (result.data || []) : [];
    const allTeam = result?.allTeam ?? result?.allTeams;
    this.allTeamsArrayDataShareService =
      result?.status && Array.isArray(allTeam) ? allTeam : [];
  }

  private subject = new Subject<any>();

  shareData(data: any) {
    this.subject.next(data);
  }

  getData(): Observable<any> {
    return this.subject.asObservable();
  }

  isMasterListLoaded(key: string): boolean {
    return !!this.masterListsLoaded[key];
  }

  markMasterListLoaded(key: string): void {
    this.masterListsLoaded[key] = true;
  }

  /** Clear shared arrays + reload flags (logout / auth conflict). */
  clearSharedMasterData(): void {
    this.teamsArrayDataShareService = [];
    this.driversArrayDataShareService = [];
    this.hubsArrayDataShareService = [];
    this.taskArrayDataShareService = [];
    this.adminArrayDataShareService = [];
    this.dispatcherArrayDataShareService = [];
    this.apiKeysArrayDataShareService = [];
    this.oauthCredentialsArrayDataShareService = [];
    this.WebhookArrayDataShareService = [];
    this.vehicleBrandArrayDataShareService = [];
    this.vehicleModelArrayDataShareService = [];
    this.vehicleArrayDataShareService = [];
    this.carTypeArrayDataShareService = [];
    this.driverShiftArrayDataShareService = [];
    this.hubZoneArrayDataShareService = [];
    this.serviceZoneArrayDataShareService = [];
    this.branchArrayDataShareService = [];
    this.surgeZoneArrayDataShareService = [];
    this.areaZoneArrayDataShareService = [];
    this.planCreatedArrayDataShareService = [];
    this.planCreatedFromTaskArrayDataShareService = [];
    this.masterListsLoaded = {};
  }
}
